import styled from 'styled-components';
import { media } from 'utils/rwd';

export const SwitcherRow = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;

  > div {
    width: 100%;
  }

  ${media.md`
    display: none;
  `}
`;

export const Workspace = styled.div`
  display: grid;
  min-width: 0;
  grid-template-columns: minmax(0, 1fr) minmax(0, 420px);
  gap: 24px;

  ${media.md.down`
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  `}
`;

export const FormPanel = styled.div`
  min-width: 0;

  ${media.md.down`
    display: ${({ $active }) => ($active ? 'block' : 'none')};
    grid-area: 1 / 1;
  `}
`;

export const PreviewPanel = styled.div`
  display: flex;
  min-width: 0;
  padding-left: 24px;
  border-left: 1px solid #e3e6e8;
  align-items: flex-start;
  justify-content: center;
  container: customer-preview / inline-size;

  ${media.md.down`
    display: ${({ $active }) => ($active ? 'flex' : 'none')};
    padding-left: 0;
    border-left: 0;
    grid-area: 1 / 1;
  `}
`;
